import { Container } from "react-grid-system";

import { Alert } from "@icg360/design-system";

import { MSSLink } from "components/common/link";
import { type InspectionEnum } from "consts";
import { useInspectionsData } from "pages/inspections/hooks";
import { trackEvent } from "utils";

import styles from "./home-services.module.scss";

const HomeServicesAlert = () => {
  const { loading, latestInspection } = useInspectionsData();

  const referrals = latestInspection?.review?.referrals;
  const statusEnum = latestInspection?.status as InspectionEnum;
  const SHOW_INSPECTION_STATUSES: InspectionEnum[] = [420, 430, 440];

  const hideAlert =
    loading ||
    !referrals?.length ||
    !SHOW_INSPECTION_STATUSES.includes(statusEnum ?? 0);

  if (hideAlert) {
    return null;
  }

  return (
    <Container className={styles.alertContainer}>
      <Alert
        appearance="danger"
        title="Repairs required."
        description={
          <>
            Please make these{" "}
            <MSSLink
              onClick={() => trackEvent("Inspection Write-Out - Alert Click")}
              to="/my/inspections"
              style={{ color: "black" }}
            >
              repairs to your property
            </MSSLink>{" "}
            to renew your policy.
          </>
        }
      />
    </Container>
  );
};

export default HomeServicesAlert;
